import TokenPageBase from '../../../components/views/NFTs/elements/token/TokenPageBase';
function TokenByUser() {
  return <TokenPageBase useCase="TokenByUser" />;
}

export default TokenByUser;
